import React from "react";
import debounce from "debounce";

import { Select, Spin, message } from "antd";

import { _getSearchEnterprise, _getTermContractBackingSellers } from "../../services";
import { BACKING_SUPPLIER_LABEL, errorMessage, escapeRegex } from "./helpers";

/**
 * Remote-search select. `initialOption` ({ value, label }) keeps the current
 * value labelled before any search has run.
 */
export class RemoteSelect extends React.Component {

    state = { options: this.props.initialOption ? [this.props.initialOption] : [], loading: false };

    componentDidMount() {
        this.search({ text: "" });
    }

    componentWillUnmount() {
        this.search.clear();
        this.unmounted = true;
    }

    search = debounce(async ({
        text,
    }) => {
        this.setState({ loading: true });
        try {
            const options = await this.props.fetchOptions({ text });
            if (this.unmounted) return;
            const { initialOption } = this.props;
            const keepInitial = initialOption && !options.some(o => o.value === initialOption.value);
            this.setState({ options: keepInitial ? [initialOption, ...options] : options });
        } catch (e) {
            message.error(errorMessage({ error: e }));
        } finally {
            if (!this.unmounted) this.setState({ loading: false });
        }
    }, 300);

    render() {
        const { value, onChange, placeholder, allowClear, style, disabled, autoFocus, defaultOpen, onBlur, onInputKeyDown } = this.props;
        const { options, loading } = this.state;
        return (
            <Select
                showSearch
                allowClear={allowClear}
                disabled={disabled}
                autoFocus={autoFocus}
                defaultOpen={defaultOpen}
                onBlur={onBlur}
                onInputKeyDown={onInputKeyDown}
                value={value || undefined}
                placeholder={placeholder}
                style={style || { width: "100%" }}
                filterOption={false}
                onSearch={text => this.search({ text })}
                onChange={v => onChange(v || null, options.find(o => o.value === v) || null)}
                notFoundContent={loading ? <Spin size="small" /> : null}
            >
                {options.map(o => <Select.Option key={o.value} value={o.value}>{o.label}</Select.Option>)}
            </Select>
        );
    }
}

const fetchEnterprises = async ({
    text,
}) => {
    const { data } = await _getSearchEnterprise({ searchTerm: encodeURIComponent(escapeRegex({ text })), page: 1, limit: 20 });
    return (data.enterprises || []).map(e => ({ value: e._id, label: e.companyName }));
};

const fetchBackingSellers = async ({
    text,
}) => {
    const { data } = await _getTermContractBackingSellers({ q: text });
    return (data.backingSellers || []).map(s => ({ value: s.id, label: s.status ? `${s.companyName} (${s.status})` : s.companyName }));
};

export const EnterpriseSelect = (props) => (
    <RemoteSelect placeholder="Search enterprise" fetchOptions={fetchEnterprises} {...props} />
);

export const BackingSellerSelect = (props) => (
    <RemoteSelect placeholder={BACKING_SUPPLIER_LABEL} allowClear fetchOptions={fetchBackingSellers} {...props} />
);



// WEBPACK FOOTER //
// ./src/components/term-contract/selects.js